module.exports = "/img/_/_/_/assets/images/avatar/full_left/male//elf.jpg?5c35a127b2c08267ebdf10f0856d504a";